// Where the arm planes sit on a post. Kept apart from the store so that the
// check in tools/check-arm-placement.js can run it without a build.

// The margin to the top of the post that the highest arm plane keeps.
export const POST_TOP_MARGIN = 50;

// The number of arm planes that fills a post. At that many they reach all the
// way up, and with fewer they are held further down. Lowering it fills at fewer.
export const ARM_PLANES_FILLING_POST = 6;

// The arm drawing of each series, in millimetres above the ground, which is also
// where the post height is counted from. firstArmStartHeight is where the
// underside of the lowest arm sits, armHeight how much the drawing occupies
// above that, bracket included. Both are read off the components, so remeasure
// if an arm or a post is redrawn.
export const ARM_DRAWING = {
	Spetsglans: { firstArmStartHeight: 577, armHeight: 192 },
	Hematit: { firstArmStartHeight: 548, armHeight: 140 },
	Brucit: { firstArmStartHeight: 434, armHeight: 120 },
	Falla: { firstArmStartHeight: 419, armHeight: 120 },
};

/**
 * Returns how far above the drawn position each arm plane sits, lowest first.
 *
 * @param brand
 * @param postHeight in millimetres
 * @param armsCount
 * @returns {number[]} in millimetres
 */
export function calculateArmPositions(brand, postHeight, armsCount) {
	let armDrawing = ARM_DRAWING[brand];

	if (!armDrawing || armsCount < 1) {
		return [];
	}

	// What is left of the post above the lowest arm, and within that the
	// highest position a plane may take. The lowest plane sits at zero.
	let availableArmPositionSpace = postHeight - armDrawing.firstArmStartHeight;
	let highestArmTopPosition = availableArmPositionSpace - armDrawing.armHeight - POST_TOP_MARGIN;

	if (armsCount === 1) {
		// A single plane sits halfway up
		return [Math.round(highestArmTopPosition / 2)];
	}

	// Spread evenly up to the highest position, but no further apart than the
	// limit allows. The limit grows with the post and with fewer planes, which
	// keeps a few of them down the post instead of stretching them out over the
	// whole of it.
	let armPosInterval = highestArmTopPosition / (armsCount - 1);

	let fillingInterval = highestArmTopPosition / (ARM_PLANES_FILLING_POST - 1);
	let maxSpacing = fillingInterval * ARM_PLANES_FILLING_POST / armsCount;

	if (armPosInterval > maxSpacing) {
		armPosInterval = maxSpacing;
	}

	// Left unrounded on purpose. Rounding the interval makes the topmost plane
	// drift with the number of planes, and rounding each position makes the gaps
	// between them differ, both by about a millimetre.
	let positions = [];

	for (let i = 0; i < armsCount; i++) {
		positions.push(i * armPosInterval);
	}

	return positions;
}
